import * as SolidIcons from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as HeroIcons from "@heroicons/react/20/solid";
import { CSSProperties, ReactElement } from "react";

import { iconsSchemas } from "../../config/entities";
import { isCustomEntityIconToken } from "../../utils/icon-utils";

type IconRendererProps = {
  className?: string;
  color?: string;
  icon: string;
  style?: CSSProperties;
};

// Unified fallback renderer
export const IconRenderer = ({
  className,
  color,
  icon,
  ...rest
}: IconRendererProps): null | ReactElement => {
  // Try Heroicons first
  const HeroIcon = HeroIcons[icon as keyof typeof HeroIcons];
  if (HeroIcon) {
    return (
      <HeroIcon
        className={className}
        style={{ color, ...rest.style }}
        {...rest}
      />
    );
  }

  // Try Font Awesome
  const faIcon = SolidIcons[icon as keyof typeof SolidIcons];
  if (faIcon) {
    return (
      <FontAwesomeIcon
        className={className}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        icon={faIcon as any}
        style={{ color, ...rest.style }}
        {...rest}
      />
    );
  }

  // Try custom icon tokens for backward compatibility
  if (isCustomEntityIconToken(icon)) {
    const CustomIcon = iconsSchemas[icon].component;
    return (
      <CustomIcon
        className={className}
        {...rest}
        style={{ color, ...rest.style }}
      />
    );
  }

  // Nothing found
  return null;
};
